var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m21.49 19.114-3.859-3.826c3.644-5.47.011-12.842-6.539-13.269S-.011 8.431 2.894 14.329a8.53 8.53 0 0 0 7.65 4.76 8.42 8.42 0 0 0 4.733-1.45l3.868 3.876a1.66 1.66 0 0 0 2.346 0 1.67 1.67 0 0 0 0-2.4M10.545 4.452c4.643 0 7.544 5.036 5.223 9.065-2.322 4.03-8.125 4.029-10.446 0a6.05 6.05 0 0 1-.808-3.013c0-3.34 2.699-6.048 6.031-6.052"
  })));
};
export default SvgSearch;